// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StickerPackPopup__container-f7364a {
  display: flex;
  flex-direction: column;
}

.StickerPackPopup__private-title-fb2d58 {
  align-self: center;
  margin: 0 auto;
  color: var(--base-70);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/StickerPackPopup/StickerPackPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n}\n\n.private-title {\n  align-self: center;\n  margin: 0 auto;\n  color: var(--base-70);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StickerPackPopup__container-f7364a`,
	"private-title": `StickerPackPopup__private-title-fb2d58`,
	"privateTitle": `StickerPackPopup__private-title-fb2d58`
};
module.exports = ___CSS_LOADER_EXPORT___;
